<nb-select id="inspectionType"
           fullWidth
           [(selected)]="value"
           [disabled]="isDisabled">
  @if (showEmptyOption()) {
    <nb-option [value]="undefined">Alle</nb-option>
  }
  <nb-option [value]="InspectionTypes.Regular">Begehung</nb-option>
  <nb-option [value]="InspectionTypes.Schadstellenplan">Schadstellenplan</nb-option>
</nb-select>
